module.exports = __webpack_public_path__ + "img/h5-star.fd3b2576.png";